export default {
  data() {
    return {
      pageRules: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isManager() {
      return (this.user && this.user.role === 'manager_kmp');
    },
    isDealer() {
      return (this.user && this.user.role === 'manager_dealer');
    },
    textForRole() {
      return (this.isDealer) ? {
        title: 'Обналичивай',
        text: 'Обменивайте баллы на подарки',
      } : {
        title: 'Выигрывай',
        text: 'Стань лучшим в рейтинге',
      };
    },
  },
  methods: {
    GetFullRules() {
      this.$store.getters.axl.post('/profiles/api/rules/list', {
        profile_id: this.user.profile_id,
      })
        .then(({ data }) => {
          this.pageRules = data.pageRules;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
  mounted() {
    this.GetFullRules();
  },
};
